/* Built In Imports */
/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import htmlParser from '@app-ihs/components/Utility/ArticleParser/htmlParser';
/* Services */

/**
 * Renders the Quote Component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - data
 * @returns {ReactElement} Quote component
 */
const Quote = ({ sectionContent, pageConfig, sectionId, lang}) => {
  const pName = pageConfig?.pageName;
  let lapOfMasterQuote = sectionId === 'lap-of-master-quote'
  let isEng = lang === 'en'
  
  return (
    <Box
      maxW="660%"
      width={pName === 'chyp' ? '100%' : '100%'}
      p={lapOfMasterQuote ? {base: isEng ? '10% 10% 3% 5%' : '10% 10% 3% 10%', md: isEng ? '4% 33% 2% 33%' : '4% 26% 2% 26%'} : { base: '15px', lg: '0% 16%', xl: '0% 16%' }}
      fontFamily={lapOfMasterQuote ? (isEng ? "FedraSansStd-book" : 'MuktaMalar') : "FedraSansStd-book-i"}
      fontSize={{ base: lapOfMasterQuote ? '20px' : 16, md: pName === 'chyp' ? '18px' : '20px' }}
      fontWeight="400"
      fontStyle={lapOfMasterQuote ? (isEng ? 'italic' : 'normal') : 'italic'}
      lineHeight={lapOfMasterQuote ? {base: '142%', md: '140%'} : "2"}
      textAlign="center"
      color={pName === 'chyp' ? '#28231E' : lapOfMasterQuote ? '#000000' : 'rgb(207 69 32)'}
      marginBottom={lapOfMasterQuote ? undefined : {base: pName === 'chyp' ? '20px' : '40px', md: pName === 'chyp' ? '70px' : '40px'}}
      bg={ lapOfMasterQuote ? '#F1EBDF' : undefined}
    >
      {/* {sectionContent?.quote} */}
      {sectionContent?.quote.split('\n').map((line, index) => (
        <Text as="span" key={index}>
          {line}
          <br />
        </Text>
      ))}
    </Box>
  );
};

export default Quote;
